import { createContext, useContext } from "react";

interface ILayerPanelContext {
  title: string;
  layerKey: string;
}

export const LayerPanelContext = createContext<ILayerPanelContext | undefined>(undefined);

export const useLayerPanelContext = (): ILayerPanelContext => {
  const context = useContext(LayerPanelContext);
  if (context === undefined) {
    throw new Error("Layer panel actions must be rendered inside a LayerPanel");
  }
  return context;
};
